import axios from "axios";
import { store } from "../Redux/store";
import { encryptHandler, decryptHandler } from "./encryptDecrypt";
import { logoutUser } from "../Pages/AdminPages/utils";
import { BASE_URL } from "./api";

store.subscribe(() => {
  const user_name = store.getState().user?.access_token;
  // const decryptedUser = user && JSON.parse(decryptHandler(user));
  // console.log("User: ", decryptedUser)
  // Now you can use the updated user state here

  // instance.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
});

const username:any = store?.getState()?.token;

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    clientId: "1",
    Authorization: `Bearer ${localStorage?.getItem("token")}`,
  },
});

instance.interceptors.request.use(
  (config) => {
    config.data = encryptHandler(config?.params || config?.data);
    config.params = {};
    // config.url = config.url + "?" + "data=" + config.data;
    // console.log(config);
    // console.log("Encrypted: ", config?.data);
    // console.log("Decrypted: ", decryptHandler(config?.data));
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// instance.interceptors.response.use(
//   (res) => {
//     const decryptedRes = decryptHandler(res?.data);
//     // if the response was stringified
//     res.data = JSON.parse(decryptedRes);
//     console.log(decryptHandler(res?.data));
//     return res;
//   },
//   async (err) => {
//     console.log(err?.response?.data);
//     console.log(err?.response?.status);
//     if (err?.response && err?.response?.status === 401 && username?.userToken?.username) {
//       // await signOut();
//       await logoutUser(username?.userToken?.username);
//     }else if(err?.response && err?.response?.status === 401 && !username?.userToken?.username){
//       localStorage.clear();
//     }

//     if (err?.response) {
//       const decryptedError = decryptHandler(err?.response?.data);
//       // console.log(decryptedError)
//       const errorInfo = decryptedError && JSON.parse(decryptedError);
//       // console.log("Instance: ", errorInfo);
//       // console.log(err?.response?.status)
//       return errorInfo;
//     }

//     // console.log("Instance: ", err);
//     return Promise.resolve(err);
//   }
// );

instance.interceptors.response.use(
  (res) => {
    const decryptedRes = decryptHandler(res?.data);
    res.data = JSON.parse(decryptedRes);
    return res;
  },
  async (err) => {
    if (err?.response && err?.response?.status === 401 && username?.userToken?.username) {
      await logoutUser(username?.userToken?.username);
    } else if (err?.response && err?.response?.status === 401 && !username?.userToken?.username) {
      localStorage.clear();
    }

    if (err?.response) {
      const decryptedError = decryptHandler(err?.response?.data);
      const errorInfo = decryptedError ? JSON.parse(decryptedError) : null;
      return Promise.reject(errorInfo || err);
    }

    return Promise.reject(err);
  }
);

export default instance;

